import React from 'react';
import styled from 'styled-components';
import Label from './Label';
import { marketplaceInputStyles } from './Common';
import Error from './Error';
import useInput from '../../../hooks/useInput';

const Input = ({ label, type, name, value, onChange, error }: any) => {
  const { focused, handleBlur, handleChange, handleFocus, hasValue } = useInput({
    onChange,
    name,
    value,
  });

  return (
    <Wrapper>
      <Label active={hasValue || focused}>{label}</Label>
      <StyledInput
        type={type}
        name={name}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        value={value}
      />
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};

export default Input;

const Wrapper = styled.label`
  display: block;
  position: relative;
`;

const StyledInput = styled.input<any>`
  width: 100%;
  height: 40px;
  ${marketplaceInputStyles}
`;
